import MuiHidden from "@material-ui/core/Hidden";

const Hidden = ({ when, ...props }) =>
  when ? <></> : <MuiHidden {...props} />;

export default Hidden;
